export default "/images/vendor/flag-icon-css/flags/4x3/gh.svg?3b04534742f8cc2f32bb02e49dd915be";